import type { FunctionComponent, ReactElement } from 'react';
import { useCallback } from 'react';

import { useCoreDispatch } from '../../../store/CoreStore';
import { toastActions } from '../../../store/slices/toast/slice';
import { Icon } from '../../icons/icon';
import { Icons } from '../../icons/iconNames';
import { Toast } from '../../toast/Toast';
import type { ToastConnectedProps } from '../types';

export const MaxWinCapToastConnected: FunctionComponent<ToastConnectedProps> = ({
  message,
  timeStamp,
  ...rest
}): ReactElement => {
  const dispatch = useCoreDispatch();

  const closeFn = useCallback(() => {
    dispatch(toastActions.removeToast(timeStamp));
  }, [dispatch, timeStamp]);

  return <Toast message={message} onClose={closeFn} icon={<Icon icon={Icons.Warning} />} {...rest} />;
};
